import React, { useContext } from "react";
import { useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import languageList from "../../../data/languageList";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";

// primaryLanguage - Select List

const R8PrimaryLanguage = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    formData: { primaryLanguage, firstName },
    onFormDataChange,
    pass: { primarylangauage },
  } = registrationContext;

  const primaryLanguagefilledout = primaryLanguage !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
       const loadBrands = async () => {
         await fetchBrands();
       };
   
       loadBrands();
     }, []);
  
     const brand_holston = brandDomains.brand_holston?.name;
     const brand_pbia = brandDomains.brand_pbia?.name;

 //findBrand is used to check whether holston forms or other forms
 if (findBrand( brand_holston) === true || findBrand(brand_pbia) === true ) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Primary Language <span>(9/11)</span>
            <hr />
          </h2>
          <div className="group">
            <div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Primary Language?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="primaryLanguage"
                  value={primaryLanguage}
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border: primarylangauage
                      ? "1px solid #ccc;"
                      : primaryLanguage !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                >
                  <option value="">Please Select </option>
                  {languageList.map((item) => {
                    return <option value={item}>{item}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <ProgressButtons
          validation={primaryLanguagefilledout}
          name="primarylangauage"
        />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Primary Language <span>(7/15)</span>
            <hr />
          </h2>
          <div className="group">
            <div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Primary Language?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="primaryLanguage"
                  value={primaryLanguage}
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border: primarylangauage
                      ? "1px solid #ccc;"
                      : primaryLanguage !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                >
                  <option value="">Please Select </option>
                  {languageList.map((item) => {
                    return <option value={item}>{item}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <ProgressButtons
          validation={primaryLanguagefilledout}
          name="primarylangauage"
        />
      </>
    );
  }
};

export default R8PrimaryLanguage;
